function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*jshint esversion: 6 */
import { StringUtils } from "./StringUtils";
export var DateTimeFormatter = /*#__PURE__*/function () {
  function DateTimeFormatter() {
    _classCallCheck(this, DateTimeFormatter);

    this._locale = localStorage.userLocale || "en";
    this._dayMonthOptions = {
      month: 'short',
      day: 'numeric'
    };
    this._shortOptions = {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    };
    this._timeOptions = {
      hour: 'numeric',
      minute: '2-digit'
    };
    this._weekDays = ['Sundays', 'Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays', 'Saturdays'];
  }
  /**
   * This function is needed to normalize date/time string value without timezone offset specified
   * which causes issues in Safari browsers
   * @param {*} dateValue - date time string
   */


  _createClass(DateTimeFormatter, [{
    key: "NormalizeDateTime",
    value: function NormalizeDateTime(dateValue) {
      if (!dateValue) return null;
      var parts = dateValue.split(/[^0-9]/).map(Number);

      var _parts = _slicedToArray(parts, 6),
          year = _parts[0],
          month = _parts[1],
          day = _parts[2],
          hour = _parts[3],
          minute = _parts[4],
          second = _parts[5];

      return parts.length >= 3 ? new Date(year, month - 1, day, hour || 0, minute || 0, second || 0) : null;
    }
  }, {
    key: "ToShortDate",
    value: function ToShortDate(dateValue) {
      if (!(dateValue = this.NormalizeDateTime(dateValue))) {
        return "";
      }

      var d = new Date(dateValue);
      return d.toLocaleDateString(this._locale, this._shortOptions);
    }
  }, {
    key: "ToShortDateTime",
    value: function ToShortDateTime(dateValue) {
      if (!(dateValue = this.NormalizeDateTime(dateValue))) {
        return "";
      }

      var d = new Date(dateValue);
      return d.toLocaleDateString(this._locale, this._shortOptions) + ' ' + d.toLocaleTimeString(this._locale, this._timeOptions);
    }
  }, {
    key: "ToShortTime",
    value: function ToShortTime(dateValue) {
      if (!(dateValue = this.NormalizeDateTime(dateValue))) {
        return "";
      }

      var d = new Date(dateValue);
      return d.toLocaleTimeString(this._locale, this._timeOptions);
    }
  }, {
    key: "ToShortDateRange",
    value: function ToShortDateRange(startDate, endDate) {
      if (!(startDate = this.NormalizeDateTime(startDate)) || !(endDate = this.NormalizeDateTime(endDate))) {
        return "";
      }

      startDate = new Date(startDate);
      endDate = new Date(endDate);
      var start = startDate.toLocaleDateString(this._locale, this._shortOptions);
      var end = endDate.toLocaleDateString(this._locale, this._shortOptions);
      return start + ' - ' + end;
    }
  }, {
    key: "ToShortDayMonthOnlyRange",
    value: function ToShortDayMonthOnlyRange(startDate, endDate) {
      if (!(startDate = this.NormalizeDateTime(startDate)) || !(endDate = this.NormalizeDateTime(endDate))) {
        return "";
      }

      startDate = new Date(startDate);
      endDate = new Date(endDate);
      var start = startDate.toLocaleDateString(this._locale, this._dayMonthOptions);
      var end = endDate.toLocaleDateString(this._locale, this._dayMonthOptions);
      return start + ' - ' + end;
    }
  }, {
    key: "ToShortDateTimeRange",
    value: function ToShortDateTimeRange(startDate, endDate) {
      if (!(startDate = this.NormalizeDateTime(startDate)) || !(endDate = this.NormalizeDateTime(endDate))) {
        return "";
      }

      startDate = new Date(startDate);
      endDate = new Date(endDate);
      var start = startDate.toLocaleDateString(this._locale, this._shortOptions);
      var end = endDate.toLocaleDateString(this._locale, this._shortOptions);

      if (start === end) {
        return start + ' ' + startDate.toLocaleTimeString(this._locale, this._timeOptions) + ' - ' + endDate.toLocaleTimeString(this._locale, this._timeOptions);
      } else {
        return start + ' ' + startDate.toLocaleTimeString(this._locale, this._timeOptions) + ' - ' + end + ' ' + endDate.toLocaleTimeString(this._locale, this._timeOptions);
      }
    }
  }, {
    key: "IsInThePast",
    value: function IsInThePast(dateValue) {
      if (!(dateValue = this.NormalizeDateTime(dateValue))) {
        return false;
      }

      return new Date(dateValue) < new Date();
    }
  }, {
    key: "IsBeforeThisDate",
    value: function IsBeforeThisDate(dateValue, dateValueToCompare) {
      if (!(dateValue = this.NormalizeDateTime(dateValue))) {
        return false;
      }

      if (!(dateValueToCompare = this.NormalizeDateTime(dateValueToCompare))) {
        return false;
      }

      return new Date(dateValue) < new Date(dateValueToCompare);
    }
  }, {
    key: "IsAfterThisDate",
    value: function IsAfterThisDate(dateValue, dateValueToCompare) {
      if (!(dateValue = this.NormalizeDateTime(dateValue))) {
        return false;
      }

      if (!(dateValueToCompare = this.NormalizeDateTime(dateValueToCompare))) {
        return false;
      }

      return new Date(dateValue) > new Date(dateValueToCompare);
    }
  }, {
    key: "GetDayOfWeekFromString",
    value: function GetDayOfWeekFromString(dayOfWeek) {
      return this._weekDays.indexOf(dayOfWeek);
    }
  }, {
    key: "GetDayOfWeekAfterThisDate",
    value: function GetDayOfWeekAfterThisDate(dateValue, dayOfWeek) {
      if (!(dateValue = this.NormalizeDateTime(dateValue))) {
        return false;
      }

      var finalDate = new Date(dateValue);
      var currentDayOfWeek = finalDate.getDay();
      var targetDayOfWeek = this.GetDayOfWeekFromString(dayOfWeek);

      while (currentDayOfWeek !== targetDayOfWeek) {
        finalDate.setDate(finalDate.getDate() + 1);
        currentDayOfWeek = finalDate.getDay();
      }

      return finalDate;
    }
  }, {
    key: "ToShortDateFormatted",
    value: function ToShortDateFormatted(dateValue) {
      var standardFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!(dateValue = this.NormalizeDateTime(dateValue))) {
        return false;
      }

      var d = dateValue ? new Date(dateValue) : new Date();
      var dd = d.getDate();
      var mm = d.getMonth() + 1;
      var yyyy = d.getFullYear();

      if (dd < 10) {
        dd = '0' + dd;
      }

      if (mm < 10) {
        mm = '0' + mm;
      }

      if (standardFormat === true) {
        return mm + '/' + dd + '/' + yyyy;
      } else {
        return yyyy + '-' + mm + '-' + dd;
      }
    }
  }, {
    key: "GetTotalMonthsBetweenDates",
    value: function GetTotalMonthsBetweenDates(startDate, endDate) {
      var start = startDate instanceof Date ? startDate : new Date(startDate);
      var end = endDate instanceof Date ? endDate : new Date(endDate);
      start.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);
      var yearDifference = end.getFullYear() - start.getFullYear();
      var monthDifference = end.getMonth() - start.getMonth();
      var totalMonths = yearDifference * 12 + monthDifference;

      if (end.getDate() < start.getDate()) {
        totalMonths--;
      }

      return totalMonths + 1;
    }
  }, {
    key: "YearDiff",
    value: function YearDiff(a, b) {
      return Math.floor(this.GetTotalMonthsBetweenDates(a, b) / 12);
    }
  }]);

  return DateTimeFormatter;
}();